import { SessionService } from 'src/app/services/session.service';
import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import firebase from 'firebase/app';

import { DialogData } from '../edit-client-form/edit-client-form.component';
import { UserRoles } from 'src/app/dictionaries/UserRoles';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { AuthService } from 'src/app/services/auth.service';
import { ThemeService, ThemeMode } from 'src/app/services/theme.service';
import { UIMessagingService } from 'src/app/services/uimessaging.service';
import { UpdateUserPasswordComponent } from '../update-user-password/update-user-password.component';
import { SimpleMessageWindowComponent } from '../ui/simple-message-window/simple-message-window.component';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss'],
  standalone: false
})
export class EditProfileComponent implements OnInit {
  emailDisabled = false;
  editUserForm: any;
  clientForm: UntypedFormGroup;
  sessionTimeOutState: boolean;
  userIsOwner: any;
  showConsultantsFolders: any;

  constructor(
    private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<EditProfileComponent>,
    private session_$: SessionService,
    private auth_$: AuthService,
    private dialog: MatDialog,
    private uiMessaging_$: UIMessagingService,
    public theme_$: ThemeService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  navigateToUsage(): void {
    this.dialogRef.close();
    this.router.navigate(['/hub/usage']);
  }

  get quotaOwnerID(): string | null {
    const user = this.auth_$.userData.value as any;
    return user?.ownerID && user?.plancode !== 'spoke' ? user.ownerID : null;
  }

  ngOnInit(): void {
    this.showConsultantsFolders = this.auth_$.userData.value['showConsultantsFolders'];
    this.userIsOwner = this.data['realRole'] === UserRoles.owner;
    this.sessionTimeOutState = this.session_$.getSessionTimeOutState();
    console.log('sessionTimeOutState :', this.sessionTimeOutState);
    const userSettings = JSON.parse(this.data['settings']);
    this.clientForm = this.fb.group({
      name: new UntypedFormControl(this.data['userName'], [Validators.required, Validators.minLength(4)]),
      email: new UntypedFormControl({ value: this.data['userEmail'], disabled: true }, [Validators.email, Validators.required])
      // sessionTimeOut: sessionTimeOutState
    });
  }

  async onSubmit() {
    if (this.clientForm.invalid) {
      return;
    }
  }

  handleShowConsultantsFoldersChange($event: MatSlideToggleChange) {
    this.auth_$.setShowConsultantsFolders($event.checked);
  }

  getErrorMessage(formControl, controlname: string, num?) {
    if (formControl.invalid) {
      if (formControl.errors.required) {
        return controlname === 'usertype' ? `You need to select a user type` : `You need to provide a ${controlname}.`;
      }

      if (formControl.errors.minlength) {
        return `The field ${controlname} requires at least ${formControl.errors.requiredLength} characters length.`;
      }

      if (formControl.errors.email) {
        return `A valid email address is required.`;
      }
    } else {
      return;
    }
  }

  handleThemeChange(event: MatButtonToggleChange): void {
    this.theme_$.setTheme(event.value as ThemeMode);
  }

  handleChange(ev) {
    if (ev.checked) {
      this.session_$.enableSessionTimeOut();
    } else {
      this.session_$.disableSessionTimeOut();
    }
  }

  handleChangePassword() {
    this.dialog
      .open(UpdateUserPasswordComponent, { width: '400px', disableClose: false, data: { mode: 'change' } })
      .afterClosed()
      .subscribe({ next: passwordData => this.handlePasswordData(passwordData) });
  }

  handlePasswordData(passwordData) {
    if (!passwordData) return;
    const { newPassword, oldPassword } = passwordData;
    const user = firebase.auth().currentUser;
    const credential = firebase.auth.EmailAuthProvider.credential(user.email, oldPassword);
    user
      .reauthenticateWithCredential(credential)
      .then(async () => {
        const result: any = await this.auth_$.updateUserPassword(newPassword);
        if (result?.error === 'PASSWORD_HISTORY') {
          this.uiMessaging_$.toastMessage('This password was recently used. Please choose a different one.', null);
          return;
        }
        this.dialog.open(SimpleMessageWindowComponent, {
          width: '300px',
          data: { message: 'Your password has been updated', title: 'Password updated' }
        });
      })
      .catch(err => {
        if (err?.code === 'auth/wrong-password') {
          this.uiMessaging_$.toastMessage('Your current password is wrong, please try again', null);
        }
      });
  }
}
